import { Component, Input } from '@angular/core';
import { ColResizeDirective } from '../../../directives/col-resize.directive';

@Component({
  selector: 'data-table',
  standalone: true,
  imports: [ColResizeDirective],
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.css',
})
export class DataTableComponent {
  @Input() loading = false;
  @Input() maxHeight = '600px';
  @Input() skeletonColumns = 5;
  @Input() skeletonRows = 6;
  /** When true, removes the outer card border/shadow (use inside already-styled cards) */
  @Input() seamless = false;
  /** Extra classes applied to the outer wrapper (e.g. Tailwind rounded-*, shadow-*) */
  @Input() wrapperClass = '';
  /** Override border-radius inline (takes precedence over CSS). e.g. '1rem' or '16px' */
  @Input() borderRadius: string | null = null;
  /** Override box-shadow inline. e.g. 'none' or '0 4px 6px rgb(0 0 0 / 0.1)' */
  @Input() shadow: string | null = null;
  /** Override border inline. e.g. 'none' or '1px solid #e5e7eb' */
  @Input() border: string | null = null;
  /** Drag-to-resize column edges (viewports 768px and wider). On by default. */
  @Input() resizable = true;
  /**
   * Name under which this table's column widths are remembered. Optional:
   * without it the widths are keyed by page path and header labels.
   */
  @Input() resizeKey: string | null = null;
  /** Accessible name for the scrollable table region, e.g. 'Delivery report'. */
  @Input() label: string | null = null;

  get skeletonRowsArr() {
    return Array(this.skeletonRows).fill(0);
  }

  get skeletonColsArr() {
    return Array(this.skeletonColumns).fill(0);
  }
}
